import { keyframes } from '@emotion/core'
import styled from '@emotion/styled'

interface IContainerProps {
  collapse?: boolean
}

export const Container = styled.div<IContainerProps>`
  align-items: center;
  display: ${props => (props.collapse ? 'inline-block' : 'flex')};
  height: ${props => (props.collapse ? '30px' : '300px')};
  justify-content: center;
  position: relative;

  ${props => (props.collapse ? 'width: 40px;' : '')}
  ${props => (props.collapse ? 'vertical-align: middle;' : '')}
`

export const ContentContainer = styled.div`
  left: 50%;
  margin: -15px 0 0 -15px;
  position: absolute;
  top: 50%;
`

const LoaderBarAnimation = keyframes`
  0% {
    transform: scale(1);
  }

  20% {
    transform: scale(1, 1.5);
  }

  40% {
    transform: scale(1);
  }
`

export const LoaderBar = styled.div`
  animation: ${LoaderBarAnimation} 1.5s ease-in-out infinite;
  background-color: #ddd;
  border-radius: 3px;
  display: inline-block;
  height: 25px;
  margin-right: 3px;
  width: 4px;

  &:nth-child(1) {
    animation-delay: 0;
  }

  &:nth-child(2) {
    animation-delay: 0.09s;
  }

  &:nth-child(3) {
    animation-delay: 0.18s;
  }

  &:nth-child(4) {
    animation-delay: 0.27s;
  }
`
